// Libraries
import React from 'react';
import {css} from 'aphrodite/no-important';
// Core
import CoreMetrics, {createExpandableMediaQueryStylesheet} from '../core/Metrics';
import CoreStyles from '../core/Styles';

export class FixedSpace extends React.Component {
    static Variant = {
        Horizontal: "horizontal", // Default
        Vertical: "vertical",
    };
    static Size = {
        XXSmall: "xx-small",
        XSmall: "x-small",
        Small: "small",
        Medium: "medium", // Default
        Large: "large",
        XLarge: "x-large",
        XXLarge: "xx-large",
    };
    render() {
        const sizeMetrics = {
            [FixedSpace.Size.XXSmall]: CoreMetrics.ElementPadding.XXSmall(),
            [FixedSpace.Size.XSmall]: CoreMetrics.ElementPadding.XSmall(),
            [FixedSpace.Size.Small]: CoreMetrics.ElementPadding.Small(),
            [FixedSpace.Size.Medium]: CoreMetrics.ElementPadding.Medium(),
            [FixedSpace.Size.Large]: CoreMetrics.ElementPadding.Large(),
            [FixedSpace.Size.XLarge]: CoreMetrics.ElementPadding.XLarge(),
            [FixedSpace.Size.XXLarge]: CoreMetrics.ElementPadding.XXLarge(),
        };
        let {variant, size} = this.props;
        if (variant == null) {
            variant = FixedSpace.Variant.Horizontal;
        }
        if (size == null) {
            size = FixedSpace.Size.Medium;
        }
        const sizeMetric = sizeMetrics[size];

        const styles = createExpandableMediaQueryStylesheet({
            horizontal: {
                width: sizeMetric,
                height: "100%",
            },
            vertical: {
                width: "100%",
                height: sizeMetric,
            },
        });

        return (
            <div className={css(styles[variant])}></div>
        );
    }
}

export class FlexibleSpace extends React.Component {
    render() {
        const styles = createExpandableMediaQueryStylesheet({
            flexibleSpace: {
                flexGrow: 1,
            },
        });
        return (
            <div className={css(styles.flexibleSpace)}></div>
        );
    }
}

export class HorizontalRule extends React.Component {
    render() {
        const styles = createExpandableMediaQueryStylesheet({
            horizontalRule: {
                // NOTE: We use this negative margin to make sure that this doesn't
                // take up any actual vertical space (since we can't specify a height of
                // 0 and get the hairline to render)
                height: 1,
                marginTop: -1,
                flexGrow: 1,
            },
        });
        return (
            <div className={css(styles.horizontalRule, CoreStyles.hairlineStrokeBottom)}></div>
        );
    }
}

export class Separator extends React.Component {
    render() {
        const styles = createExpandableMediaQueryStylesheet({
            separator: {
                // NOTE: We use this negative margin to make sure that this doesn't
                // take up any actual horizontal space (since we can't specify a height
                // of 0 and get the hairline to render)
                width: 1,
                height: CoreMetrics.IconSize.Medium(),
                marginLeft: -1,
            },
        });
        return (
            <div className={css(styles.separator, CoreStyles.hairlineStrokeRight)}></div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/core/Spacing.jsx